/*
 * @Date: 2020-07-29 14:01:25
 * @LastEditTime: 2023-08-21 18:13:33
 * @Description:
 */
import { isTest } from '@/utils/tools'
import Request from '../../utils/request'

export const IndexServer = {
  getGuestYouLikeLecture() {
    return Request.$get('/api/index/random_lectures', {})
  },
  record(params: { category: number }) {
    return Request.$get('/api/index/record', { params })
  },
  getHomeData() {
    return Request.$get('/api/index/info', {})
  },
  getFloatCoupon(params?: { bag_id: number; need_ab?: number; category?: string }) {
    return Request.$get('/operating/api/bag/display', { params })
  },
  getNavIcon() {
    return Request.$get('/operating/api/index/get_icons', {})
  },
  searchhotConfig(params?: { sex: string }) {
    return Request.$get('/operating/api/search/hot_config', { params })
  },
  getRecommendChannel(params: { key: string }) {
    return Request.$get('/api/homepage/novelty', { params})
    // return Request.$get('/operating/api/novelty', { params })
  },
  getAdvertisingApi() {
    return Request.$get('/operating/api/outer/get_wksettings?model_name=common-index-banner&key=common-index-banner', {})
  },
  addMoniter() {
    return Request.$get('/operating/api/activity_statsd/activity_front_page/info', {})
  },
  getWindowInfo() {
    return Request.$get(`${isTest() ? location.origin : ''}/popwindow/split_flow/get_window_info`, {})
  },
  getTrainingInfo() {
    return Request.$get(`${isTest() ? 'https://dbg.weike.fm' : ''}/oc_operating/api/front_page/new_class`, {})
  }
}

export default IndexServer



// WEBPACK FOOTER //
// ./src/services/Modules/indexServer.ts